module.exports = __webpack_public_path__ + "media/assets/faria_products/FARIA1-46ef543eed4f962923975a225a63039fb6e2b42b97aefd6f6e3fd10b40346b14.png";